import { IntakeNoteComprehensiveHealthQuestionnaire } from 'src/graphql.generated'
import { IntakeNoteComprehensiveFormType } from '../IntakeNoteComprehensiveFormSchema'

type WithUndefinedOnProps<T> = { [K in keyof T]: T[K] | undefined }

type HealthQuestionnairePHQ9 =
  IntakeNoteComprehensiveFormType['REASON_FOR_SEEKING_TREATMENT']['HEALTH_QUESTIONNAIRE']['PHQ9']
type HealthQuestionnaireGAD7 =
  IntakeNoteComprehensiveFormType['REASON_FOR_SEEKING_TREATMENT']['HEALTH_QUESTIONNAIRE']['GAD7']

type HealthQuestionnaireFormFields = {
  PHQ9: WithUndefinedOnProps<HealthQuestionnairePHQ9>
  GAD7: WithUndefinedOnProps<HealthQuestionnaireGAD7>
}

export type HealthQuestionnaireFormPartial = Partial<HealthQuestionnaireFormFields>

export const mapHealthQuestionnaireToForm = (
  questionnaire?: IntakeNoteComprehensiveHealthQuestionnaire | null
): HealthQuestionnaireFormFields | Record<string, never> => {
  if (!questionnaire) return {}

  return {
    PHQ9: {
      QUESTION1: questionnaire.phq9?.PHQ9_QUESTION_1 ?? undefined,
      QUESTION2: questionnaire.phq9?.PHQ9_QUESTION_2 ?? undefined,
      QUESTION3: questionnaire.phq9?.PHQ9_QUESTION_3 ?? undefined,
      QUESTION4: questionnaire.phq9?.PHQ9_QUESTION_4 ?? undefined,
      QUESTION5: questionnaire.phq9?.PHQ9_QUESTION_5 ?? undefined,
      QUESTION6: questionnaire.phq9?.PHQ9_QUESTION_6 ?? undefined,
      QUESTION7: questionnaire.phq9?.PHQ9_QUESTION_7 ?? undefined,
      QUESTION8: questionnaire.phq9?.PHQ9_QUESTION_8 ?? undefined,
      QUESTION9: questionnaire.phq9?.PHQ9_QUESTION_9 ?? undefined,
      TOTAL_SCORE: questionnaire.phq9?.PHQ9_SCORE ?? undefined,
    },
    GAD7: {
      QUESTION1: questionnaire.gad7?.GAD7_QUESTION_1 ?? undefined,
      QUESTION2: questionnaire.gad7?.GAD7_QUESTION_2 ?? undefined,
      QUESTION3: questionnaire.gad7?.GAD7_QUESTION_3 ?? undefined,
      QUESTION4: questionnaire.gad7?.GAD7_QUESTION_4 ?? undefined,
      QUESTION5: questionnaire.gad7?.GAD7_QUESTION_5 ?? undefined,
      QUESTION6: questionnaire.gad7?.GAD7_QUESTION_6 ?? undefined,
      QUESTION7: questionnaire.gad7?.GAD7_QUESTION_7 ?? undefined,
      TOTAL_SCORE: questionnaire.gad7?.GAD7_SCORE ?? undefined,
    },
  }
}
